<template>
    <div>
      <navbar :title="fad" :box="box"/>
<van-tabs v-model="actives" scrollspy sticky>
  <van-tab v-for="(key,value) in posts" :key="value" :title="value">
        <van-card @click="showPopup(item.sto_Guid,item.sto_kod,item.eldeki_miktar,item.sto_isim,item.sto_marka_kodu)" v-for="(item,index) in posts[value]" :key="index"
        :num="item.eldeki_miktar+' '+item.sto_birim1_ad"
        :title="item.sto_isim"
        :desc="item.sto_kod+'-'+item.sto_marka_kodu"
        :price="parabirimi(item.satis_fiyat)"
        :currency="''"
        :thumb="'https://bayiistoc.com/upload/'+item.sto_kod+'.jpg'">
        </van-card> 
 </van-tab>

</van-tabs>

<van-popup style="background:white;"
  v-model="show2"
  round
  closeable
  close-icon="close"
  position="bottom"
  :style="{ height: '60%' }"
>

<div style="padding:0 10px; margin:10px 0px">
<van-cell :title="selected.isim" :label="selected.kod+' '+selected.marka" />

<van-grid :column-num="2">
  <van-grid-item>
    <van-image width="3rem" height="3rem" fit="cover" :src="'https://bayiistoc.com/upload/'+selected.kod+'.jpg'"
    />     
  </van-grid-item>
  <van-grid-item icon="photo-o" text="Text">
    <van-cell-group>
      <van-cell style="text-align:center"  :title="' Stok : '+selected.adet+' Adet'"/>
      <van-cell><van-stepper  :max="selected.adet" min="1" v-model="gelenadet" input-width="30px" button-size="46px" /></van-cell>
    </van-cell-group>
  </van-grid-item>
</van-grid>
  <van-button @click="sepetekle(selected.guid,selected.adet)"  style="margin-top:10px" size="large" type="primary" block>Sepete Ekle</van-button>
</div>
</van-popup>
    <van-popup v-model="show"><van-loading type="spinner" color="#fff" /></van-popup>
    </div>
</template>

<script>
import {helper} from '@/helper';
import { userService } from '@/plugins/_services';
import { Notify } from 'vant';
import navbar from './nav'
export default {
components:{
navbar
},
  data() {
    return {
      grup:this.$route.params.name,
      posts:[],
      sepet:'',
      show:false,
      show2:false,
      active:'Ürünler',
      digerleri:[],
      currentTag:'All',
      actives:'',
      selected:{},
      gelenadet:0,
      fad:'Kampanyalı Ürünler',
      box:JSON.parse(localStorage.getItem('osmBox')).baskets.length || 0
    };
  },

created (){
this.show = true
userService.handleResponse(helper.settings.ayar().username,helper.settings.ayar().pass)
.then(res => { this.getProduct() }
)
.catch(err => {userService.logout()})
},
methods : {
  showPopup(guids,kods,adets,isims,markas) {
    this.selected = {};
    this.gelenadet = 1 ; // farklı ürün açılınca rakam sıfırlama
      Object.assign(this.selected, {guid:guids,kod:kods,adet:adets,isim:isims,marka:markas})
      this.show2 = true;
    },
  sepetekle(guid,adet) {
    this.show = true
  // burada aslında adet almaya gerek yok ama ilerde anlık stok kontrolü yapmak için kullanılabilir
        var gelenadet = this.gelenadet;
        if (adet >= gelenadet){
        let urun = { guid:guid,adet:gelenadet}
        const basket = localStorage.getItem('osmBox');
        if (basket){
          var items = JSON.parse(localStorage.getItem('osmBox')) || [];
          var index = items.baskets.findIndex(obj => obj.guid==guid);
           if (index === -1){
            
            items.baskets.push(urun) // bunu push etmezsem içeriyi boşaltıp en son üürünü atıyor
            localStorage.setItem('osmBox', JSON.stringify(items))
            this.box++
            this.show = false
            Notify({ type: 'success', message: gelenadet +' Adet Eklendi' });
           // this.$emit('sepetadet');
           
            //this.box++
           }
           else{
            items.baskets[index].adet = parseInt(items.baskets[index].adet) + parseInt( gelenadet) 
            localStorage.setItem('osmBox', JSON.stringify(items))
            this.show = false
            Notify({ type: 'success', message: gelenadet +' Adet Eklendi' });

           }
        }
        else{
          this.box++
          localStorage.setItem('osmBox',JSON.stringify({"baskets":[urun]}))
          this.show = false
          Notify({ type: 'success', message: gelenadet +' Adet Eklendi' });
          //this.$emit('sepetadet');
          
        }
          }
         else{Notify({ type: 'danger', message: 'Yeterli Stok Yok' });}
            // setTimeout(() => {
            //   this.sepetliste()
            // }, 200);
      
      },    
      getProduct(){
          helper.request.get('mikro/kampanya/'+helper.settings.ayar().kod)
          .then(response=>{
            this.posts = response.reduce((acc, item) => {
                if (!acc[item["sto_marka_kodu"]]){
                  acc[item["sto_marka_kodu"]] = []
                }
                acc[
                  item["sto_marka_kodu"]
                  ].push(item)
                return acc
                }, {});
              this.show = false
          })
          .catch(err => {alert(err)})
          //this.gruplar();
          //this.sepetliste()
        },
  parabirimi(res){
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(res).replace("€","TL")
  },    
  gruplar(){
    JSON.parse(sessionStorage.getItem('grup')).forEach(element => {
      this.digerleri.push(element.sto_anagrup_kod)
  });},
  groupByAdet (array, key) { 
       return array.reduce((acc, item) => {
        const accAmout = acc[item[key]] || 0;
         return Object.assign(
            {}, acc, {
            [item[key]]: accAmout + 1,
          }
         )
        }
        , {})
    },

} 
};
</script>


// WEBPACK FOOTER //
// src/components/kampanyali.vue